/* --------------------------------------------------------------------------
   TT-COLLECTION - the one control on the page that needs script.

   Everything else filters through real links: a tag path ANDs natively, so
   multi-select, deep links and the back button all work with JavaScript off,
   and <details> is native markup. Sort is the exception - a <select> cannot
   navigate by itself.

   PROGRESSIVE, NOT REQUIRED. Liquid renders a submit button beside the select;
   this hides it and submits on change instead. With no script the button is
   still there and the form still works, so the control is never a dead end.
   Hiding it from script rather than from CSS is the whole point: if this file
   fails to load, the fallback is visible.
   -------------------------------------------------------------------------- */

(function () {
  'use strict';

  if (window.__ttCollection) return;
  window.__ttCollection = true;

  /* DELEGATED FROM THE DOCUMENT, not bound per form on load. The toolbar this
     select lives in is replaced wholesale every time a filter is applied
     (tt-collection-async.js), and a listener bound to the old <select> goes with
     it — so sorting worked exactly once per page load. Delegation survives the
     swap; so does the button-hiding, which is why that moved into the handler's
     own pass rather than staying a one-time sweep. */
  document.addEventListener('change', function (event) {
    var select = event.target.closest('.tt-sort__select');
    if (!select) return;
    var form = select.closest('.tt-sort');
    if (!form) return;
    /* requestSubmit fires the form's own submit handling; submit() would skip
       it — and skipping it would skip the async swap. Falling back matters for
       older Safari. */
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.submit();
  });

  /* The no-JavaScript submit button. Hidden from script rather than from CSS on
     purpose: if this file fails to load, the fallback is visible. Run on load
     and on every section render, since a swapped-in toolbar brings a fresh one. */
  function hideSubmits() {
    document.querySelectorAll('.tt-sort__go').forEach(function (go) { go.hidden = true; });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideSubmits);
  } else {
    hideSubmits();
  }
  document.addEventListener('shopify:section:load', hideSubmits);
  /* tt-collection-async.js fires this after each swap. */
  document.addEventListener('tt:collection:swapped', hideSubmits);
})();
